import { render, staticRenderFns } from "./composer.vue?vue&type=template&id=b13ef79a"
import script from "./composer.vue?vue&type=script&lang=js"
export * from "./composer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports